<script>
  import { isDev, imgSrc } from '$client';
  export let data;

  $: if (!data && isDev())
    data = {
      header: 'Бесплатный расчёт по фото',
      background: 'linear-gradient(95deg, rgb(47, 50, 74) 20%, rgb(66, 72, 103) 80%)',
      img: { data: { attributes: { src: 'https://admin.uberi.pro/uploads/icons8_telegram_48_1_c04868fd87.png' } } },
      mobilePosition: 'south-east',
      href: '/',
      color: '#f0f1f1 !important',
      position: 'east-southeast',
      imgPosition: false,
    };
</script>

<a
  style="background:{data.background};"
  href={data.href}
  data-image={Boolean(data.img.data)}
  data-image-position={data.imgPosition}
  data-position={data.position}
  target="_blank"
  rel="nofollow"
  data-mobile-position={data.mobilePosition}>
  <span style="color:{data.color};">{data.header}</span>
  {#if data.img}
    <img src={imgSrc(data.img.data.attributes.url)} alt={data.img.data.attributes.alternativeText} />
  {/if}
</a>

<style lang="scss">
  /* stylelint-disable scss/dollar-variable-pattern */
  /* stylelint-disable selector-class-pattern */
  /* stylelint-disable no-duplicate-selectors */

  /**
  ** Corner button positions **
  *? east-northeast - right border / top;
  *? east-southeast - right border / bottom;
  *? west-northwest - left border / top;
  *? west-southwest - left border / bottom;
  *? north-northeast - top border / right;
  *? north-northwest - top border / left;
  *? south-southwest - bottom border / left;
  *? south-southeast - bottom border / right;
  *? south - bottom border / center;
  *? west - left border / center;
  *? east - right border / center;
  *? north - top border / center;
  */

  @media only screen and (min-width: 991.98px) {
    $borderX: 30px;
    $borderY: 30px;
    $height: 40px;
    $width: 200px;
    $lradius: 8px;
    $rradius: 30px;
    $border: 3px;

    a:not(a[data-position='disabled']) {
      z-index: 100;
      display: flex;
      align-items: center;
      width: auto;
      min-width: $width;
      height: $height;
      overflow: hidden;
      box-shadow: 0 12px 14px 8px rgb(0 0 0 / 17%);
      transform-style: preserve-3d;

      span {
        z-index: 2;
        min-width: 160px;
        font-weight: bold;
        font-size: 16px;
        font-family: Vela Sans;
      }

      img {
        z-index: 2;
        float: right;
        height: 105%;
        margin-right: 36px;
        margin-left: 7px;
        padding: 12px;
        object-fit: cover;
        aspect-ratio: 1 / 1;
      }

      &[data-image-position='false'] {
        flex-direction: row-reverse;
        justify-content: flex-end;

        span {
          margin-right: 36px;
        }

        img {
          margin-right: 7px;
          margin-left: 8px;
        }
      }

      &[data-image-position='true'] {
        span {
          margin: 0 16px;
        }

        img {
          margin-right: 16px;
        }
      }

      &[data-image='false'] {
        min-width: $width - 50px;

        span {
          margin: 0 37px 0 16px;
        }
      }
    }

    a:not(a[data-position='disabled']) {
      position: fixed;

      &[data-position='east-northeast'],
      &[data-position='east-southeast'],
      &[data-position='east'] {
        right: 0;
        border-top-left-radius: $lradius;
        border-top-right-radius: $rradius;
        transform-origin: bottom right;
        rotate: -90deg;
      }

      &[data-position='east-northeast'] {
        top: $borderY;
      }

      &[data-position='east-southeast'] {
        bottom: $borderY;
        transform: translateX(100%);
      }

      &[data-position='west-northwest'],
      &[data-position='west-southwest'],
      &[data-position='west'] {
        left: 0;
        border-bottom-right-radius: $rradius;
        border-bottom-left-radius: $lradius;
        transform-origin: top left;
        rotate: -90deg;
      }

      &[data-position='west-northwest'] {
        top: $borderY;
        transform: translateX(-100%);
      }

      &[data-position='west-southwest'] {
        bottom: $borderY;
      }

      &[data-position='north-northeast'],
      &[data-position='north-northwest'],
      &[data-position='north'] {
        top: 0;
        border-bottom-right-radius: $rradius;
        border-bottom-left-radius: $lradius;
      }

      &[data-position='north-northeast'],
      &[data-position='south-southwest'] {
        right: $borderX;
      }

      &[data-position='north-northwest'],
      &[data-position='south-southeast'] {
        left: $borderX;
      }

      &[data-position='south-southwest'],
      &[data-position='south-southeast'],
      &[data-position='south'] {
        bottom: 0;
        border-top-left-radius: $lradius;
        border-top-right-radius: $rradius;
      }

      &[data-position='south'] {
        left: 50%;
        translate: -50% 0;
      }

      &[data-position='north'] {
        left: 50%;
        translate: -50% 0;
      }

      &[data-position='east'] {
        bottom: 50%;
        transform: translateX(50%);
      }

      &[data-position='west'] {
        top: 50%;
        transform: translateX(-50%);
      }
    }
  }

  /**
    ** Round button positions **
    *? SW - bottom left angle;
    *? SE - bottom right angle;
    *? NW - top left angle;
    *? NE - top right angle;
    *? S - bottom / center;
    *? W - left / center;
    *? E - righ / center;
    *? N - top / center;
  */

  @media only screen and (max-width: 991.98px) {
    $borderX: 20px;
    $borderY: 20px;
    $height: 60px;
    $width: 60px;
    $border: 3px;

    a:not(a[data-mobile-position='disabled']) {
      z-index: 100;
      display: flex;
      align-items: center;
      justify-content: center;
      width: $width;
      height: $height;
      border-radius: 50%;
      transform-style: preserve-3d;
      cursor: pointer;

      span {
        display: none;
      }

      img {
        z-index: 2;
        float: right;
        width: $width - 30px;
        height: $height - 30px;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: contain;
      }
    }

    a:not(a[data-mobile-position='disabled']) {
      position: fixed;

      &[data-mobile-position='south-west'] {
        bottom: $borderY;
        left: $borderX;
      }

      &[data-mobile-position='north-east'] {
        top: $borderY;
        right: $borderX;
      }

      &[data-mobile-position='north-west'] {
        top: $borderY;
        left: $borderX;
      }

      &[data-mobile-position='south-east'] {
        right: $borderX;
        bottom: $borderY;
      }

      &[data-mobile-position='south'] {
        bottom: $borderY;
        left: 50%;
        translate: -50% 0;
      }

      &[data-mobile-position='north'] {
        top: $borderY;
        left: 50%;
        translate: -50% 0;
      }

      &[data-mobile-position='east'] {
        top: 50%;
        translate: 0 -50%;
        right: $borderX;
      }

      &[data-mobile-position='west'] {
        top: 50%;
        translate: 0 -50%;
        left: $borderX;
      }
    }
  }
</style>
